export function Updates() {
  return (
    <div className="updates">
      <p>
        {" "}
        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          height="52"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#95d5b2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="login-updates"
        >
          <rect x="2" y="6" width="20" height="8" rx="1" />
          <path d="M17 14v7" />
          <path d="M7 14v7" />
          <path d="M17 3v3" />
          <path d="M7 3v3" />
          <path d="M10 14 2.3 6.3" />
          <path d="m14 6 7.7 7.7" />
          <path d="m8 6 8 8" />
        </svg> */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="72"
          height="72"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#95d5b2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="login-updates"
        >
          <rect x="2" y="6" width="20" height="8" rx="1" />
          <path d="M17 14v7" />
          <path d="M7 14v7" />
          <path d="M17 3v3" />
          <path d="M7 3v3" />
          <path d="M10 14 2.3 6.3" />
          <path d="m14 6 7.7 7.7" />
          <path d="m8 6 8 8" />
        </svg>
      </p>
      <ul>
        <strong>
          Dieses Projekt befindet sich noch in Arbeit, folgende Features sollen
          noch integriert werden:
        </strong>
        <li>Gäste verwalten</li>
        <li>Statistiken implementieren</li>
        <li>Mitarbeiter hinzufügen</li>
        <li>Zimmer verwalten (Status sauber/schmutzig)</li>
      </ul>
    </div>
  );
}
